import { Button, FormControlLabel, Radio, RadioGroup, Tab, Tabs } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { SERVICE_DETAIL_COMPONENT } from '../../../../constants/UiBuilderConst';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import CTASelector from '../../../../shared/ui-builder/cta-selector/CTA-Selector';
import EmailSelector from '../../../../shared/ui-builder/email-selector/Email-Selector';
import PhoneSelector from '../../../../shared/ui-builder/phone-selector/Phone-Selector';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//8 product Service detail
const ServiceDetailPage = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;

  const initialState = {
    isTitleActive: true,
    titleH2: '',
    body: '',
    cta: {
      isActive: true,
      title: '',
    },
    redirectLink: {
      isActive: true,
      connection: 'IN_APP',
      linkId: '',
      flowSubSelection: '',
    },
    phone: {
      isActive: true,
      number: '',
    },
    email: {
      isActive: true,
      address: '',
    },
    images: [
      {
        id: `image_1`,
        label: `Image 1`,
        imgURL: '',
        videoURL: null,
        shadowOverlay: false,
        loopPlayBack: false,
        isVideo: false,
      },
      {
        id: `image_2`,
        label: `Image 2`,
        imgURL: '',
        videoURL: null,
        shadowOverlay: false,
        loopPlayBack: false,
        isVideo: false,
      },
    ],
    highLights: {
      isActive: true,
      highLightList: [{ highLight: '' }, { highLight: '' }],
    },
  };

  const [configState, setConfigState] = useState(
    config?.body
      ? [config]?.map((e) => {
          return {
            ...e,
            highLights: {
              isActive: e?.highlights?.isActive || false,
              highLightList: e?.highlights?.highlightList || [{ highLight: '' }, { highLight: '' }],
            },
            images: e?.images?.map((img, index) => ({
              ...img,
              id: `image_${index + 1}`,
              label: `Image ${index + 1}`,
            })),
          };
        })[0]
      : initialState,
  );
  const [titleStatus, setTitleStatus] = useState(
    configState?.isTitleActive ? 'active' : 'inactive',
  );
  const [highlightsStatus, setHighlightsStatus] = useState(
    configState?.highLights?.isActive ? 'active' : 'inactive',
  );
  const [activeImage, setActiveImage] = useState(0);
  const [activeHighlight, setActiveHighlight] = useState(0);
  const [error, setError] = useState(null);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);

  useEffect(() => {
    onItemChange({
      componentName: SERVICE_DETAIL_COMPONENT,
      config: [configState]?.map((conf) => {
        return {
          ...conf,
          images: conf?.images?.map(({ id, label, ...keepAttrs }) => keepAttrs),
        };
      })[0],
    });
  }, [configState, isSwapEnabled]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === SERVICE_DETAIL_COMPONENT,
      );
      if (currError && currError.images.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.images.map((o) => o.pos),
        );
        setActiveImage(sliderNdx);
      }
      if (currError && currError.highLights.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.highLights.map((o) => o.pos),
        );
        setActiveHighlight(sliderNdx);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    } else {
      if (val.type) return '';
      return 'required';
    }
  };

  const handleTabData = (val, slideContent, field) => {
    let rawValue;
    if (val && val?.target && typeof val?.target?.value !== 'undefined') {
      rawValue = val?.target?.value;
    } else {
      rawValue = val;
    }
    const trimmed = typeof rawValue === 'string' ? rawValue?.trim() : rawValue;
    let currError = error;
    if (!currError) {
      currError = {
        pos: componentNdx,
        id: SERVICE_DETAIL_COMPONENT,
        config: {},
        images: [],
        highLights: [],
      };
    }
    currError.config = {
      ...currError?.config,
      [field]: setErrorField(field, trimmed),
    };
    if (field === 'highLight') {
      if (!currError?.highLights || !currError?.highLights?.length) {
        currError.highLights = configState?.highLights?.highLightList?.map((_, pos) => ({ pos }));
      }
      currError.highLights = currError?.highLights?.map((errObj) =>
        errObj?.pos === activeHighlight
          ? { ...errObj, highLight: setErrorField(field, trimmed) }
          : errObj,
      );
    }
    setError(currError);
    const tempConfigState = { ...configState };
    switch (field) {
      case 'backgroundColor':
        tempConfigState.backgroundColor = val;
        break;
      case 'titleH2':
        tempConfigState.titleH2 = rawValue;
        break;
      case 'titleStatus':
        tempConfigState.isTitleActive = val.target.value === 'active';
        setTitleStatus(val.target.value);
        break;
      case 'body':
        tempConfigState.body = rawValue;
        break;
      case 'imgURL':
        const tempImages = tempConfigState.images;
        tempImages[activeImage].imgURL = val;
        tempConfigState.images = tempImages;
        if (val) setIsSwapEnabled(false);
        break;
      case 'shadowOverlay':
        const tempImagesOver = tempConfigState.images;
        tempImagesOver[activeImage].shadowOverlay = val;
        tempConfigState.images = tempImagesOver;
        break;
      case 'highlightsStatus':
        const highLights = { ...tempConfigState.highLights };
        highLights.isActive = val.target.value === 'active';
        if (
          val.target.value === 'active' &&
          (!highLights.highLightList || !highLights.highLightList.length)
        ) {
          highLights.highLightList = [{ highLight: '' }, { highLight: '' }];
        }
        tempConfigState.highLights = highLights;
        setHighlightsStatus(val.target.value);
        break;
      case 'highLight':
        const tempHighLights = { ...tempConfigState?.highLights };
        if (tempHighLights?.highLightList && tempHighLights?.highLightList[activeHighlight]) {
          tempHighLights.highLightList[activeHighlight].highLight = rawValue;
          tempConfigState.highLights = tempHighLights;
        }
        break;
      case 'redirect':
        tempConfigState.redirectLink.connection = val.type;
        tempConfigState.redirectLink.linkId = val.value;
        tempConfigState.redirectLink.flowSubSelection = val.flowSubSelection;
        break;
      case 'isCTAActive':
        tempConfigState.redirectLink.isActive = val;
        tempConfigState.cta.isActive = val;
        break;
      case 'CTA':
        tempConfigState.cta.title = val;
        break;
      case 'email':
        tempConfigState.email.address = val;
        break;
      case 'isEmailActive':
        tempConfigState.email.isActive = val;
        break;
      case 'phone':
        tempConfigState.phone.number = val;
        break;
      case 'isPhoneActive':
        tempConfigState.phone.isActive = val;
        break;
      case 'isVideo':
        const tempIsVideo = tempConfigState.images;
        tempIsVideo[activeImage].isVideo = val;
        tempConfigState.images = tempIsVideo;
        break;
      case 'videoURL':
        const tempVideo = tempConfigState.images;
        tempVideo[activeImage].videoURL = val;
        tempConfigState.images = tempVideo;
        break;
      case 'loopPlayBack':
        const tempLoopBack = tempConfigState.images;
        tempLoopBack[activeImage].loopPlayBack = val;
        tempConfigState.images = tempLoopBack;
        break;
      default:
        break;
    }
    setConfigState(tempConfigState);
  };

  const onActiveImageChange = (e, activeImageIndex) => {
    setActiveImage(activeImageIndex);
  };

  const onAddNewImageTab = (e) => {
    const tempConfig = { ...configState };
    const tempImages = [...tempConfig.images];
    tempImages.push({
      id: `image_${tempImages.length + 1}`,
      label: `Image ${tempImages.length + 1}`,
      imgURL: '',
      shadowOverlay: false,
    });
    tempConfig.images = tempImages;
    setConfigState(tempConfig);
  };

  const onClickRemoveImage = (e) => {
    if (configState.images.length > 1) {
      const tempConfig = { ...configState };
      const tempImages = [...tempConfig.images];
      tempImages.splice(activeImage, 1);
      if (activeImage === tempImages.length) {
        setActiveImage(tempImages.length - 1);
      }
      tempConfig.images = tempImages;
      setConfigState(tempConfig);
    }
  };

  const onActiveHighLightChange = (e, activeHighlightIndex) => {
    setActiveHighlight(activeHighlightIndex);
  };

  const onAddNewHighlightTab = (e) => {
    const tempConfig = { ...configState };
    const tempHighLightList = [...tempConfig.highLights.highLightList];
    tempHighLightList.push({ highLight: '' });
    setActiveHighlight(tempHighLightList.length - 1);
    tempConfig.highLights.highLightList = tempHighLightList;
    setConfigState(tempConfig);
  };

  const onClickRemoveHighlight = (e) => {
    if (configState.highLights.highLightList.length > 1) {
      const tempConfig = { ...configState };
      const tempHighLights = { ...tempConfig.highLights };
      const tempHighlightList = [...tempHighLights.highLightList];
      tempHighlightList.splice(activeHighlight, 1);
      if (activeHighlight === tempHighlightList.length) {
        setActiveHighlight(tempHighlightList.length - 1);
      }
      tempHighLights.highLightList = tempHighlightList;
      tempConfig.highLights = tempHighLights;
      setConfigState(tempConfig);
    }
  };

  const hasImageError = (key, isReturnString = false) => {
    const hasSliderError = error?.images?.find(
      (errorSlider) =>
        errorSlider.pos === activeImage &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl'),
    );
    if (isReturnString && hasSliderError) return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const hasHighLightError = (key) => {
    const hasSliderError = error?.highLights?.find(
      (errorSlider) => errorSlider.pos === activeHighlight && errorSlider[key] === 'required',
    );
    if (hasSliderError) return true;
    return false;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const tempConfig = { ...configState };
    const newTabs = [...tempConfig.images];
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    tempConfig.images = newTabs;
    setConfigState(tempConfig);
    setActiveImage(result.destination.index);

    setIsSwapEnabled(true);
    onItemChange({
      componentName: SERVICE_DETAIL_COMPONENT,
      config: [configState]?.map((conf) => {
        return {
          ...conf,
          images: conf?.images?.map(({ id, label, ...keepAttrs }) => keepAttrs),
        };
      })[0],
    });
  };

  const onHighlightsDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const tempConfig = { ...configState };
    const newHighlights = [...tempConfig.highLights.highLightList];
    const draggedHighlight = newHighlights?.splice(result?.source?.index, 1)[0];
    newHighlights?.splice(result?.destination?.index, 0, draggedHighlight);
    tempConfig.highLights.highLightList = newHighlights;
    setConfigState(tempConfig);
    setActiveHighlight(result?.destination?.index);

    setIsSwapEnabled(true);
    onItemChange({
      componentName: SERVICE_DETAIL_COMPONENT,
      config: [configState]?.map((conf) => {
        return {
          ...conf,
          images: conf?.images?.map(({ id, label, ...keepAttrs }) => keepAttrs),
        };
      })[0],
    });
  };

  return (
    <>
      <div className='row my-2 mx-4 mt-4'>
        <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
          <DraggableTabsList
            onDragEnd={onDragEnd}
            tabs={configState?.images}
            onTabChange={onActiveImageChange}
            activeTabIndex={activeImage}
          />
          <div className='ms-2'>
            <Button
              disabled={configState?.images?.length > 7}
              variant='outlined'
              size='medium'
              color='secondary'
              onClick={(e) => onAddNewImageTab(e)}
            >
              <Add />
            </Button>
          </div>
        </div>
        <div className='mt-3 mx-2 d-flex justify-content-between px-3 py-2 remove-slide-div'>
          <div>Image {configState?.images[activeImage]?.id?.split('_')[1]}</div>
          <div className='text-underlined pointer' onClick={(e) => onClickRemoveImage(e)}>
            Remove
          </div>
        </div>
        <div className='col-md-12 mt-4'>
          <MediaSelector
            groupId={groupId}
            titleH2={'Image'}
            height={780}
            width={780}
            handleTabData={handleTabData}
            activeTabContent={configState?.images[activeImage]}
            isSwapEnabled={isSwapEnabled}
            setIsSwapEnabled={setIsSwapEnabled}
            hasError={hasImageError}
            ratio={'1:1'}
            matrix={'px Full Bleed'}
          />
        </div>
        <div>
          <div className='col-md-12 redirect-selector'>
            <div className='row align-items-center mb-2 mt-3'>
              <div className='col-md-4 title'>Page Title</div>
              <div className='col-md-8'>
                <RadioGroup
                  row
                  aria-label='statusValue'
                  onChange={(e) => handleTabData(e, configState, 'titleStatus')}
                  value={titleStatus}
                  className='document-type'
                  name='row-radio-buttons-group'
                >
                  <FormControlLabel
                    value='active'
                    control={<Radio color='primary' />}
                    label='Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='inactive'
                    control={<Radio color='primary' />}
                    label='Inactive'
                  />
                </RadioGroup>
              </div>
            </div>
            {configState?.isTitleActive && (
              <CustomUiBuilderTextField
                label='H2 Title'
                required={configState?.isTitleActive}
                className='col-md-12 mt-2'
                value={configState?.titleH2}
                onChangeInput={(e) => handleTabData(e, configState, 'titleH2')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={!isSwapEnabled && error?.config?.titleH2 === 'required' ? true : false}
              />
            )}
            <CustomUiBuilderTextField
              label='Body2'
              required={true}
              className='col-md-12 mt-3'
              value={configState?.body}
              onChangeInput={(e) => handleTabData(e, configState, 'body')}
              maxLength={500}
              isAdornment={true}
              multiline={true}
              endAdornment={true}
              error={!isSwapEnabled && error?.config?.body === 'required' ? true : false}
            />
          </div>
          <div className='col-md-12 redirect-selector'>
            <div className='row align-items-center mb-2 mt-3'>
              <div className='col-md-4 title'>Highlights</div>
              <div className='col-md-8'>
                <RadioGroup
                  row
                  aria-label='statusValue'
                  onChange={(e) => handleTabData(e, configState, 'highlightsStatus')}
                  value={highlightsStatus}
                  className='document-type'
                  name='row-radio-buttons-group'
                >
                  <FormControlLabel
                    value='active'
                    control={<Radio color='primary' />}
                    label='Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='inactive'
                    control={<Radio color='primary' />}
                    label='Inactive'
                  />
                </RadioGroup>
              </div>
            </div>
            {configState?.highLights?.isActive && (
              <div>
                <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
                  <DraggableTabsList
                    onDragEnd={onHighlightsDragEnd}
                    tabs={configState?.highLights?.highLightList?.map((highlight, index) => ({
                      id: `highlight_${index + 1}`,
                      label: `Highlight ${index + 1}`,
                    }))}
                    onTabChange={onActiveHighLightChange}
                    activeTabIndex={activeHighlight}
                  />
                  <Tabs
                    value={activeHighlight}
                    variant='fullWidth'
                    indicatorColor='primary'
                    onChange={onActiveHighLightChange}
                    aria-label='tabs'
                    textColor='primary'
                    className='tabs'
                  >
                    {configState?.highlights?.highLightList?.map((image, index) => (
                      <Tab key={index} label={`Highlight ${index + 1}`} />
                    ))}
                  </Tabs>
                  <div className='ms-2'>
                    <Button
                      disabled={configState?.highLights?.highLightList?.length > 7}
                      variant='outlined'
                      size='medium'
                      color='secondary'
                      onClick={(e) => onAddNewHighlightTab(e)}
                    >
                      <Add />
                    </Button>
                  </div>
                </div>
                <div className='mt-3 mx-2 d-flex justify-content-between px-3 py-2 remove-slide-div'>
                  <div>Highlight {activeHighlight + 1}</div>
                  <div
                    className='text-underlined pointer'
                    onClick={(e) => onClickRemoveHighlight(e)}
                  >
                    Remove
                  </div>
                </div>
                <div>
                  <CustomUiBuilderTextField
                    label={'Highlight ' + (activeHighlight + 1)}
                    required={true}
                    className='col-md-12 mt-3'
                    value={
                      configState?.highLights?.highLightList?.length
                        ? configState?.highLights?.highLightList[activeHighlight]?.highLight
                        : ''
                    }
                    onChangeInput={(e) => handleTabData(e, configState, 'highLight')}
                    maxLength={60}
                    isAdornment={true}
                    endAdornment={true}
                    error={!isSwapEnabled && hasHighLightError('highLight')}
                  />
                </div>
              </div>
            )}
          </div>
          <div className='col-md-12 mt-4'>
            <EmailSelector
              onValueChange={(e) => handleTabData(e, configState, 'email')}
              value={configState?.email?.address}
              onEmailStatusChange={(e) => {
                handleTabData(e, configState, 'isEmailActive');
              }}
              isActive={configState?.email?.isActive}
              error={
                !isSwapEnabled &&
                (error?.config?.email === 'required' || error?.config?.email === 'validEmail')
                  ? true
                  : false
              }
              maxLength={'1048'}
            />
          </div>
          <div className='col-md-12 mt-4'>
            <PhoneSelector
              onValueChange={(e) => handleTabData(e, configState, 'phone')}
              value={configState?.phone?.number}
              onPhoneStatusChange={(e) => {
                handleTabData(e, configState, 'isPhoneActive');
              }}
              isActive={configState?.phone?.isActive}
              error={!isSwapEnabled && error?.config?.phone === 'required' ? true : false}
              maxLength={'15'}
            />
          </div>
          <div className='col-md-12 mt-4'>
            <CTASelector
              isLabelDisabled={true}
              redirectAndCtaOneName={'CTA & Redirect'}
              onValueChange={(e) => handleTabData(e, configState, 'CTA')}
              value={configState?.cta?.title}
              onCTAStatusChange={(e) => {
                handleTabData(e, configState, 'isCTAActive');
              }}
              isActive={configState?.cta?.isActive}
              error={!isSwapEnabled && error?.config?.CTA === 'required' ? true : false}
            />
          </div>
          {configState?.cta?.isActive && (
            <div className='col-md-12 mt-4'>
              <RedirectSelector
                areButtonsDisabled={true}
                isNameDisabled={true}
                onValueChange={(e) => handleTabData(e, configState, 'redirect')}
                redirectType={configState.redirectLink.connection}
                value={configState.redirectLink.linkId}
                onRedirectChange={(e) => {
                  handleTabData(e, configState, 'isActive');
                }}
                isActive={configState.redirectLink.isActive}
                error={
                  !isSwapEnabled &&
                  (error?.config?.redirect === 'required' || error?.config?.redirect === 'validUrl')
                    ? true
                    : false
                }
                showFlowSubSelection={true}
                flowSubSelection={configState.redirectLink.flowSubSelection}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ServiceDetailPage;
